import {
  Table,
  Row,
  Column,
  HeaderRow,
  HeaderColumn,
  BuyIcon, DeleteIcon, Market,
  SellIcon, TableWrapper, TextWithMargin
} from "../../styles/OrdersStyle";
import { FlexCenter, PercentText } from "../../styles/CommonStyles";
import { formatDate, formatNumber, variants } from "../../utils/common"
import { AnimatePresence } from "framer-motion";
import FilterLayout from "../../layouts/FilterLayout";
import ModalLayout from "../../layouts/ModalLayout";
import OrdersDeleteModal from "../../modals/OrdersDeleteModal";
import { useMainContext } from "../../contexts/main";
import Text from "../../utils/Text";
import { SOCKET_URL } from "../../constants/urls";
import {useCurrentOrders} from "../../hooks/useOrdersHook";
import {OrdersBody} from "../../styles/OrdersStyle";


const CurrentOrders = ({ hasFilters }) => {

  const {
    currentOrders, setDeleteModal,
    allPages, filterQueries,
    setFilterQueries, initialState,
    isFetching, deleteModal,
    onModalClicked
  } = useCurrentOrders()

  return (
    <>
      <OrdersBody>
          {hasFilters ?
              <FilterLayout
                  headers={headers}
                  data={currentOrders}
                  totalPages={allPages}
                  state={{ filterQueries, setFilterQueries, initialState }}
                  loading={isFetching}
                  hasCoinOption
                  hasTypeOptions
                  hasTradeOptions
              >
                  <CurrentOrdersTable setDeleteModal={setDeleteModal} currentOrders={currentOrders} />
              </FilterLayout>
              :
              <>
                  <HeaderRow>
                      {headers.map(header => (
                          <HeaderColumn key={header.title} width={header.width}>
                              <Text tid={header.title} />
                          </HeaderColumn>
                      ))}
                  </HeaderRow>
                  <CurrentOrdersTable
                      setDeleteModal={setDeleteModal}
                      currentOrders={currentOrders}
                  />
              </>
          }
      </OrdersBody>
      <ModalLayout
        width="450px"
        open={deleteModal.open}
        onClose={() => setDeleteModal({ id: null, open: false })}
      >
        <OrdersDeleteModal onModalBtnClicked={onModalClicked} />
      </ModalLayout>
    </>
  );
};



const CurrentOrdersTable = ({ currentOrders, setDeleteModal }) => {
  const { main: { lang } } = useMainContext()

  return (
    <AnimatePresence exitBeforeEnter>
      <TableWrapper height="230px" variants={variants} initial="out" animate="in" exit="out">
        <Table width="100%">
          {currentOrders?.data?.map((item, index) => {
            return (
              <Row key={item._id}>
                <Column>
                  <FlexCenter>
                    <img
                      width="22px"
                      height="22px"
                      src={
                        SOCKET_URL +
                        `assets/icon/${item?.coin?.toLowerCase()}.png`
                      }
                      alt={`${item.id?.toLowerCase()}.png`}
                    />
                    <Market>{`${item.coin?.toUpperCase()}/${item.pair?.toUpperCase()}`}</Market>
                  </FlexCenter>
                </Column>
                <Column number>{formatNumber(item.amount)}</Column>
                <Column number>{formatNumber(item.priceUnit)}</Column>
                <Column number>{formatNumber(item.price)}</Column>
                <Column>
                  <FlexCenter>
                    {item.type === "buy" ?
                      <BuyIcon />
                      :
                      <SellIcon />
                    }
                    <TextWithMargin type={item.type}>
                      <Text tid={item.type} />
                    </TextWithMargin>
                  </FlexCenter>
                </Column>
                <Column>{item.submit}</Column>
                <Column number>{formatDate(item.createdAt, "date", lang === "en" ? "en-US" : "fa-IR")}</Column>
                <Column number>{formatDate(item.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}</Column>
                <Column width="9%" number>{
                  <PercentText pc={item.tradedAmount * 100 / (item.amount + item.tradedAmount)}>
                    {Math.round(item.tradedAmount * 100 / (item.amount + item.tradedAmount))}%
                  </PercentText>
                }</Column>
                <Column width="2.2%">
                  <DeleteIcon onClick={() => setDeleteModal({ id: item._id, open: true })} />
                </Column>
              </Row>
            );
          })}
        </Table>
      </TableWrapper>
    </AnimatePresence>
  )
}

const headers = [
  { title: "market", width: "11.1%" },
  { title: "amount", width: "11.1%" },
  { title: "unitPrice", width: "11.1%" },
  { title: "totalPrice", width: "11.1%" },
  { title: "transactionType", width: "11.1%" },
  { title: "tradeType", width: "11.1%" },
  { title: "date", width: "11.1%" },
  { title: "timeHour", width: "11.1%" },
  { title: "donePc", width: "11.1%" }
]

export default CurrentOrders;
